/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SettingForecastHistoryPage = lazyLoad(
  () => import('./index'),
  module => module.SettingForecastHistoryPage
);
